// React 与浏览器翻译扩展（Google 翻译 / Immersive Translate 等）兼容补丁。
//
// 背景：翻译扩展会改写/替换页面文本节点；当 React 随后对这些节点执行
// insertBefore / removeChild 时，目标节点已不再是原父节点的子节点，
// 浏览器抛 NotFoundError："Failed to execute 'insertBefore'/'removeChild' on 'Node'…"，
// 在多语言站点上量很大，并可能因 React 反复重试演变为 "Maximum call stack size exceeded"。
//
// 方案：参考 React 官方 issue(facebook/react#11538) 的通用做法，
// 对 Node.prototype.insertBefore / removeChild 做防御式包装：当父子关系已被破坏时
// 优雅降级（直接返回目标节点）而非抛异常，从而避免崩溃与误报。
//
// 仅在浏览器端执行一次。

let patched = false

export function patchDomForTranslation() {
  if (patched) return
  if (typeof window === 'undefined' || typeof Node === 'undefined' || !Node.prototype) return
  patched = true

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      // 节点已被翻译扩展移走，忽略本次移除，避免 NotFoundError
      return child
    }
    return originalRemoveChild.call(this, child) as T
  } as typeof Node.prototype.removeChild

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      // 参考节点已被翻译扩展移走，退化为 appendChild，避免 NotFoundError
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  } as typeof Node.prototype.insertBefore
}
